import { render, staticRenderFns } from "./infor.vue?vue&type=template&id=a1443da6&"
import script from "./infor.vue?vue&type=script&lang=js&"
export * from "./infor.vue?vue&type=script&lang=js&"
import style0 from "./infor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports